export default {
  PAGINATE: 'photo_library/PAGINATE',

  USER_PHOTOS_REQUEST: 'photo_library/USER_PHOTOS_REQUEST',
  USER_PHOTOS_SUCCESS: 'photo_library/USER_PHOTOS_SUCCESS',
  USER_PHOTOS_FAILURE: 'photo_library/USER_PHOTOS_FAILURE',

  PHOTO_UPLOAD_START: 'photo_library/PHOTO_UPLOAD_START',
  PHOTO_UPLOAD_SUCCESS: 'photo_library/PHOTO_UPLOAD_SUCCESS',
  PHOTO_UPLOAD_FAILURE: 'photo_library/PHOTO_UPLOAD_FAILURE',

  PHOTO_DELETE_REQUEST: 'photo_library/PHOTO_DELETE_REQUEST',
  PHOTO_DELETE_SUCCESS: 'photo_library/PHOTO_DELETE_SUCCESS',
  PHOTO_DELETE_FAILURE: 'photo_library/PHOTO_DELETE_FAILURE',
}
